import { SearchComponentConfiguration } from "@utils/search/@types/searchConfiguration";
import { SearchRoutePrefix } from "@utils/search/routing/@types/route.types";
import { mapDefault } from "@utils/search/routing/configurationToUrl/mappers/mapDefault";
import { mapFacetsConfiguration } from "@utils/search/routing/configurationToUrl/mappers/mapFacetsConfiguration";

export type RouteEntry = readonly [string, string | number];

export type MayBeConfigurationToRouteEntriesMapper = (
    configuration: SearchComponentConfiguration,
    prefix: SearchRoutePrefix,
) => Array<RouteEntry> | null;

const mayBeConfigurationToRouteEntriesMappers: Array<MayBeConfigurationToRouteEntriesMapper> =
    [mapFacetsConfiguration, mapDefault];

const mapToRouteEntries = (
    configuration: SearchComponentConfiguration,
    prefix: SearchRoutePrefix,
) => {
    for (const mayBeConfigurationToRouteMapper of mayBeConfigurationToRouteEntriesMappers) {
        const routeEntries = mayBeConfigurationToRouteMapper(
            configuration,
            prefix,
        );

        if (routeEntries) {
            return routeEntries;
        }
    }
};

export { mapToRouteEntries };
